import React, { useState } from 'react';
import { useApp } from '../context/AppContext';

const PRODUCTS = [
  { id:1, name:'Standard Evaluation', sku:'EVAL-STD', price:10  },
  { id:2, name:'Premium Evaluation',  sku:'EVAL-PRE', price:25  },
  { id:3, name:'Club — Pro Plan',     sku:'CLUB-PRO', price:49  },
  { id:4, name:'Club — Enterprise',   sku:'CLUB-ENT', price:199 },
];

const INITIAL_QUOTES = [
  { id:'QT-001', name:'Arsenal FC — Premium Package',    contact:'James Morris',  company:'Arsenal FC', total:2100, status:'Accepted',  created:'Mar 20, 2026', expires:'Apr 20, 2026' },
  { id:'QT-002', name:'Man City — Enterprise Proposal',  contact:'Emma Thompson', company:'Man City',   total:2388, status:'Sent',      created:'Apr 1, 2026',  expires:'May 1, 2026'  },
  { id:'QT-003', name:'Juventus — Onboarding Quote',     contact:'Luca Bianchi',  company:'Juventus',   total:248,  status:'Draft',     created:'Apr 3, 2026',  expires:'May 3, 2026'  },
  { id:'QT-004', name:'PSG — Club Trial',                contact:'Pierre Dubois', company:'PSG',        total:199,  status:'Declined',  created:'Mar 10, 2026', expires:'Apr 10, 2026' },
];

const statusBadge = s => ({ Accepted:'badge badge-green', Sent:'badge badge-blue', Draft:'badge badge-gray', Declined:'badge badge-red' })[s] || 'badge badge-gray';

export default function Quotes({ toast }) {
  const [quotes, setQuotes]     = useState(INITIAL_QUOTES);
  const [creating, setCreating] = useState(false);
  const [viewing, setViewing]   = useState(null);
  const [newQuote, setNewQuote] = useState({ name:'', contact:'', company:'', expires:'', lineItems:[{ productId:1, qty:1 }] });

  const addLineItem = () => setNewQuote(p => ({ ...p, lineItems:[...p.lineItems, { productId:1, qty:1 }] }));
  const updateItem  = (i,k,v) => setNewQuote(p => ({ ...p, lineItems: p.lineItems.map((li,idx) => idx===i ? {...li,[k]:v} : li) }));
  const removeItem  = i => setNewQuote(p => ({ ...p, lineItems: p.lineItems.filter((_,idx) => idx!==i) }));

  const calcTotal = () => newQuote.lineItems.reduce((s,li) => s + ((PRODUCTS.find(p=>p.id===parseInt(li.productId))?.price || 0) * (parseInt(li.qty)||0)), 0);

  const createQuote = () => {
    if (!newQuote.name || !newQuote.contact) { toast?.('Fill in name and contact', 'error'); return; }
    const q = { id:`QT-00${quotes.length+1}`, ...newQuote, total: calcTotal(), status:'Draft', created: new Date().toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}) };
    setQuotes(p => [q, ...p]);
    setCreating(false);
    setNewQuote({ name:'', contact:'', company:'', expires:'', lineItems:[{ productId:1, qty:1 }] });
    toast?.('Quote created');
  };

  const viewQuote = quotes.find(q => q.id === viewing);

  if (viewQuote) return (
    <div>
      <button className="btn btn-ghost" style={{ marginBottom:16, fontSize:13 }} onClick={() => setViewing(null)}>← Back to quotes</button>
      <div className="card" style={{ maxWidth:640 }}>
        <div style={{ display:'flex', justifyContent:'space-between', marginBottom:16 }}>
          <div>
            <div style={{ fontWeight:600, fontSize:18, color:'var(--text-primary)', marginBottom:4 }}>{viewQuote.name}</div>
            <div style={{ fontSize:12, color:'var(--text-dim)' }}>{viewQuote.id} · {viewQuote.contact} · {viewQuote.company}</div>
          </div>
          <span className={statusBadge(viewQuote.status)}>{viewQuote.status}</span>
        </div>
        <div style={{ background:'var(--bg-input)', borderRadius:8, padding:16, marginBottom:16 }}>
          <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, color:'var(--text-dim)', marginBottom:8 }}><span>Created</span><span>{viewQuote.created}</span></div>
          <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, color:'var(--text-dim)' }}><span>Expires</span><span>{viewQuote.expires}</span></div>
        </div>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 0', borderTop:'1px solid var(--border)' }}>
          <span style={{ fontWeight:600, color:'var(--text-primary)' }}>Total</span>
          <span style={{ fontWeight:700, fontSize:20, color:'var(--accent)' }}>${viewQuote.total.toLocaleString()}</span>
        </div>
        <div style={{ display:'flex', gap:8, marginTop:16 }}>
          <button className="btn btn-primary" style={{ fontSize:12 }} onClick={() => { setQuotes(p=>p.map(q=>q.id===viewQuote.id?{...q,status:'Sent'}:q)); toast?.('Quote sent'); setViewing(null); }}>Send quote</button>
          <button className="btn btn-ghost" style={{ fontSize:12 }} onClick={() => setViewing(null)}>Close</button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Total quotes</div><div className="stat-value">{quotes.length}</div><div className="stat-sub">All time</div></div>
        <div className="stat-card"><div className="stat-label">Accepted</div><div className="stat-value">{quotes.filter(q=>q.status==='Accepted').length}</div><div className="stat-sub stat-up">Won</div></div>
        <div className="stat-card"><div className="stat-label">Pending</div><div className="stat-value">{quotes.filter(q=>q.status==='Sent').length}</div><div className="stat-sub">Awaiting response</div></div>
        <div className="stat-card"><div className="stat-label">Total value</div><div className="stat-value">${quotes.filter(q=>q.status==='Accepted').reduce((s,q)=>s+q.total,0).toLocaleString()}</div><div className="stat-sub stat-up">Accepted quotes</div></div>
      </div>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <h3 style={{ fontFamily:'var(--font-display)', fontSize:16, fontWeight:500, color:'var(--text-primary)' }}>Quotes</h3>
        <button className="btn btn-primary" onClick={() => setCreating(true)}>+ New quote</button>
      </div>

      {creating && (
        <div className="card" style={{ marginBottom:16, padding:'16px 20px' }}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:12 }}>
            <input className="search-input" placeholder="Quote name *" value={newQuote.name} onChange={e=>setNewQuote(p=>({...p,name:e.target.value}))} />
            <input className="search-input" placeholder="Contact name *" value={newQuote.contact} onChange={e=>setNewQuote(p=>({...p,contact:e.target.value}))} />
            <input className="search-input" placeholder="Company" value={newQuote.company} onChange={e=>setNewQuote(p=>({...p,company:e.target.value}))} />
            <input type="date" value={newQuote.expires} onChange={e=>setNewQuote(p=>({...p,expires:e.target.value}))}
              style={{ background:'var(--bg-input)', border:'1px solid var(--border)', borderRadius:6, color:'var(--text-primary)', fontSize:13, padding:'8px 10px' }} />
          </div>
          <div style={{ marginBottom:12 }}>
            <div style={{ fontSize:12, color:'var(--text-dim)', marginBottom:8 }}>Line items</div>
            {newQuote.lineItems.map((li,i) => (
              <div key={i} style={{ display:'flex', gap:8, marginBottom:8, alignItems:'center' }}>
                <select value={li.productId} onChange={e=>updateItem(i,'productId',e.target.value)}
                  style={{ flex:2, background:'var(--bg-input)', border:'1px solid var(--border)', borderRadius:6, color:'var(--text-primary)', fontSize:13, padding:'7px 10px' }}>
                  {PRODUCTS.map(p=><option key={p.id} value={p.id}>{p.name} — ${p.price}</option>)}
                </select>
                <input type="number" min="1" value={li.qty} onChange={e=>updateItem(i,'qty',e.target.value)}
                  style={{ width:70, background:'var(--bg-input)', border:'1px solid var(--border)', borderRadius:6, color:'var(--text-primary)', fontSize:13, padding:'7px 10px' }} />
                <span style={{ fontSize:13, color:'var(--accent)', minWidth:60 }}>${((PRODUCTS.find(p=>p.id===parseInt(li.productId))?.price||0)*(parseInt(li.qty)||0)).toLocaleString()}</span>
                {newQuote.lineItems.length > 1 && <button className="btn btn-ghost" style={{ fontSize:11, color:'var(--danger)', padding:'4px 8px' }} onClick={()=>removeItem(i)}>✕</button>}
              </div>
            ))}
            <button className="btn btn-ghost" style={{ fontSize:12 }} onClick={addLineItem}>+ Add line item</button>
          </div>
          <div style={{ fontSize:14, fontWeight:600, color:'var(--accent)', marginBottom:12 }}>Total: ${calcTotal().toLocaleString()}</div>
          <div style={{ display:'flex', gap:8 }}>
            <button className="btn btn-primary" onClick={createQuote}>Create quote</button>
            <button className="btn btn-ghost" onClick={() => setCreating(false)}>Cancel</button>
          </div>
        </div>
      )}

      <div className="card" style={{ padding:0 }}>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Quote</th><th>Contact</th><th>Total</th><th>Status</th><th>Expires</th><th></th></tr></thead>
            <tbody>
              {quotes.map(q => (
                <tr key={q.id} style={{ cursor:'pointer' }} onClick={() => setViewing(q.id)}>
                  <td><div style={{ fontWeight:500, color:'var(--accent)' }}>{q.name}</div><div style={{ fontSize:11, color:'var(--text-dim)' }}>{q.id}</div></td>
                  <td style={{ fontSize:12 }}>{q.contact}<br/><span style={{ color:'var(--text-dim)' }}>{q.company}</span></td>
                  <td style={{ fontWeight:600, color:'var(--accent)' }}>${q.total.toLocaleString()}</td>
                  <td><span className={statusBadge(q.status)}>{q.status}</span></td>
                  <td style={{ fontSize:12, color:'var(--text-dim)' }}>{q.expires}</td>
                  <td><button className="btn btn-ghost" style={{ fontSize:11 }} onClick={e=>{e.stopPropagation();setViewing(q.id);}}>View</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
